export * from './pimAssetsCarouselMapper';
